import HeaderPage from './HeaderPage.jsx';

export default HeaderPage;
